import lazyScreen from '../utils/lazyScreen';
const GLAccounts = lazyScreen(() => import('../pages/gl/GLAccounts/index.js'), 'pages/gl/GLAccounts/index.js');
const GLCostCenter = lazyScreen(() => import('../pages/gl/GLCostCenter/index.js'), 'pages/gl/GLCostCenter/index.js');
const GLCostCenters = lazyScreen(() => import('../pages/gl/GLCostCenters/index.js'), 'pages/gl/GLCostCenters/index.js');
const GLJournal = lazyScreen(() => import('../pages/gl/GLJournal/index.js'), 'pages/gl/GLJournal/index.js');
const GLJournals = lazyScreen(() => import('../pages/gl/GLJournals/index.js'), 'pages/gl/GLJournals/index.js');
const GLPostedJournals = lazyScreen(() => import('../pages/gl/GLPostedJournals/index.js'), 'pages/gl/GLPostedJournals/index.js');
const GLGeneralLedgers = lazyScreen(() => import('../pages/gl/GLGeneralLedgers/index.js'), 'pages/gl/GLGeneralLedgers/index.js');
const GLGeneralLedgerDetails = lazyScreen(() => import('../pages/gl/GLGeneralLedgerDetails/index.js'), 'pages/gl/GLGeneralLedgerDetails/index.js');
const GLAdjustBalance = lazyScreen(() => import('../pages/gl/GLAdjustBalance/index.js'), 'pages/gl/GLAdjustBalance/index.js');
const GLAdjustBalances = lazyScreen(() => import('../pages/gl/GLAdjustBalances/index.js'), 'pages/gl/GLAdjustBalances/index.js');
const GLTrialBalances = lazyScreen(() => import('../pages/gl/GLTrialBalances/index.js'), 'pages/gl/GLTrialBalances/index.js');
const GLBalanceSheets = lazyScreen(() => import('../pages/gl/GLBalanceSheets/index.js'), 'pages/gl/GLBalanceSheets/index.js');
const GLServeCosting = lazyScreen(() => import('../pages/gl/GLServeCosting/index.js'), 'pages/gl/GLServeCosting/index.js');
const GLServeCostings = lazyScreen(() => import('../pages/gl/GLServeCostings/index.js'), 'pages/gl/GLServeCostings/index.js');
const GLMFCosting = lazyScreen(() => import('../pages/gl/GLMFCosting/index.js'), 'pages/gl/GLMFCosting/index.js');
const GLMFCostings = lazyScreen(() => import('../pages/gl/GLMFCostings/index.js'), 'pages/gl/GLMFCostings/index.js');
const GLPNLCalculate = lazyScreen(() => import('../pages/gl/GLPNLCalculate/index.js'), 'pages/gl/GLPNLCalculate/index.js');
const GLPNLCalculates = lazyScreen(() => import('../pages/gl/GLPNLCalculates/index.js'), 'pages/gl/GLPNLCalculates/index.js');
const GLPNLReports = lazyScreen(() => import('../pages/gl/GLPNLReports/index.js'), 'pages/gl/GLPNLReports/index.js');
const GLPeriodClosing = lazyScreen(() => import('../pages/gl/GLPeriodClosing/index.js'), 'pages/gl/GLPeriodClosing/index.js');
const GLPeriodClosings = lazyScreen(() => import('../pages/gl/GLPeriodClosings/index.js'), 'pages/gl/GLPeriodClosings/index.js');
const GLCashFlowReports = lazyScreen(() => import('../pages/gl/GLCashFlowReports/index.js'), 'pages/gl/GLCashFlowReports/index.js');
const GLEquityChanges = lazyScreen(() => import('../pages/gl/GLEquityChanges/index.js'), 'pages/gl/GLEquityChanges/index.js');
const GLEntityLedgers = lazyScreen(() => import('../pages/gl/GLEntityLedgers/index.js'), 'pages/gl/GLEntityLedgers/index.js');
const GLEntityLedgerDetails = lazyScreen(() => import('../pages/gl/GLEntityLedgerDetails/index.js'), 'pages/gl/GLEntityLedgerDetails/index.js');
const GLFXRevaluation = lazyScreen(() => import('../pages/gl/GLFXRevaluation/index.js'), 'pages/gl/GLFXRevaluation/index.js');
const GLFXRevaluations = lazyScreen(() => import('../pages/gl/GLFXRevaluations/index.js'), 'pages/gl/GLFXRevaluations/index.js');

// GLAccountingPolicy dành cho cầu nối kế toán hai chiều trong tương lai.
// Chưa mở màn hình cho tới khi có đủ đẩy, kéo và đối soát dữ liệu ngoài.

export default [
    {
        path: '/gl/GLAccounts',
        component: GLAccounts
    },
    {
        path: '/gl/GLCostCenters',
        component: GLCostCenters
    },
    {
        path: '/gl/GLCostCenter/:code',
        component: GLCostCenter
    },
    {
        path: '/gl/GLJournal/:code',
        component: GLJournal
    },
    {
        path: '/gl/GLJournals',
        component: GLJournals
    },
    {
        path: '/gl/GLPostedJournals',
        component: GLPostedJournals
    },
    {
        path: '/gl/GLGeneralLedgers',
        component: GLGeneralLedgers
    },
    {
        path: '/gl/GLGeneralLedgerDetails',
        component: GLGeneralLedgerDetails
    },
    {
        path: '/gl/GLAdjustBalance/:code',
        component: GLAdjustBalance
    },
    {
        path: '/gl/GLAdjustBalances',
        component: GLAdjustBalances
    },
    {
        path: '/gl/GLTrialBalances',
        component: GLTrialBalances
    },
    {
        path: '/gl/GLBalanceSheets',
        component: GLBalanceSheets
    },
    {
        path: '/gl/GLServeCosting/:code',
        component: GLServeCosting
    },
    {
        path: '/gl/GLServeCostings',
        component: GLServeCostings
    },
    {
        path: '/gl/GLMFCosting/:code',
        component: GLMFCosting
    },
    {
        path: '/gl/GLMFCostings',
        component: GLMFCostings
    },
    {
        path: '/gl/GLPNLCalculate/:code',
        component: GLPNLCalculate
    },
    {
        path: '/gl/GLPNLCalculates',
        component: GLPNLCalculates
    },
    {
        path: '/gl/GLPNLReports',
        component: GLPNLReports
    },
    {
        path: '/gl/GLPeriodClosing/:code',
        component: GLPeriodClosing
    },
    {
        path: '/gl/GLPeriodClosings',
        component: GLPeriodClosings
    },
    {
        path: '/gl/GLCashFlowReports',
        component: GLCashFlowReports
    },
    {
        path: '/gl/GLEquityChanges',
        component: GLEquityChanges
    },
    {
        path: '/gl/GLEntityLedgers',
        component: GLEntityLedgers
    },
    {
        path: '/gl/GLEntityLedgerDetails',
        component: GLEntityLedgerDetails
    },
    {
        path: '/gl/GLFXRevaluations',
        component: GLFXRevaluations
    },
    {
        path: '/gl/GLFXRevaluation/:code',
        component: GLFXRevaluation
    }
];
